import { ENDPOINTS, APPS_SCRIPT_URL } from "./constants";
import {
  clearSessionAuthToken,
  getSessionAuthToken,
} from "./global";

export const ABORT_ERROR = "REQUEST_ABORTED";
const GENERIC_ERROR = "Oops something went wrong!";

export const makeApiRequests = async ({ requestType, requestBody }) => {
  const token = getSessionAuthToken();

  try {
    const response = await (
      await fetch(APPS_SCRIPT_URL, {
        method: "POST",
        body: JSON.stringify({
          ...(token ? { accessToken: token } : {}),
          requestType,
          payload: requestBody,
        }),
        headers: { "Content-Type": "text/plain;charset=utf-8" },
      })
    ).json();

    if (response.success) return { response };
    return { error: response.message || GENERIC_ERROR };
  } catch {
    return { error: GENERIC_ERROR };
  }
};

export const sizeOf = (string) => {
  const bytes = new TextEncoder().encode(string).length;
  return bytes / (1024 * 1024);
};

const handleUnauthorized = (endpoint, message) => {
  const isSessionProbe = endpoint === ENDPOINTS.GET_ME;
  const isAuthPage = window.location.pathname.includes("/login");

  if (!isSessionProbe && !isAuthPage) {
    setTimeout(() => {
      window.location.href = "/login";
    }, 1500);
  }

  if (isSessionProbe) return message || "Unauthorized";
  return "Your session has expired, please try logging in again!";
};

export const makeRESTApiRequests = async ({
  endpoint,
  contentType = "application/json",
  requestBody,
  method = "POST",
  stringify = true,
  signal,
}) => {
  const headers = {};
  if (endpoint !== ENDPOINTS.FILE) {
    headers["Content-Type"] = contentType;
  }

  try {
    const response = await fetch(process.env.REACT_APP_API_URL + endpoint, {
      method,
      body: requestBody
        ? stringify
          ? JSON.stringify(requestBody)
          : requestBody
        : undefined,
      headers,
      credentials: "include",
      signal,
    });

    const responseBody = await response.json();

    if (response.status < 200 || response.status >= 300) {
      if (response.status === 401) {
        clearSessionAuthToken();
        return {
          error: handleUnauthorized(endpoint, responseBody.message),
          unauthorized: true,
        };
      }
      if (response.status === 429) {
        return {
          error: responseBody.message || "Too many requests, please try again later.",
          rateLimited: true,
        };
      }
      return { error: responseBody.message || GENERIC_ERROR };
    }

    return { response: responseBody };
  } catch (e) {
    if (e.name === "AbortError") return { error: ABORT_ERROR };
    return { error: GENERIC_ERROR };
  }
};
